<template>
   <Page type="gray">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <VcardDetail />
            </div>  
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Page from '@/components/sides/Page.vue'
import VcardDetail from '@/components/admin/vcard/detail.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        Page,
        VcardDetail
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>